import React from 'react';
import { Phone, AlertTriangle, CheckCircle, Wrench } from 'lucide-react';
export function DriveShaftRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-6032">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-6033">
        <div className="container mx-auto px-4" data-id="element-6034">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-6035">
            Drive Shaft Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-6036">
            Drive Shaft Repair near you! Farmington Hills, Farmington, Novi,
            Livonia, Northville
          </p>
          <p className="text-lg text-gray-200 text-center mt-2" data-id="element-6037">Since 1958</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-6038">
        <div className="max-w-4xl mx-auto" data-id="element-6039">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6040">
            <p className="text-lg text-gray-700 mb-4" data-id="element-6041">
              The drive shaft turns your axles, and your axle (or axles if it's
              a 4X4) turns your wheels. There are different types of drivelines
              depending on whether your vehicle has rear wheel drive, front
              wheel drive (FWD), four-wheel drive (4WD or 4X4), or all-wheel
              drive (AWD).
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-6042">
              The driveline (drive shaft) connects to the transmission and
              differential through a series of universal joints (often called
              u-joints).
            </p>

            <p className="text-lg text-gray-700" data-id="element-6043">
              Most universal and CV joints are sealed and don't require periodic
              lubrication. However, it's extremely important to have them
              inspected once a year and every time your vehicle is up on a lift
              (while getting oil changes).
            </p>
          </div>

          {/* Warning Signs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6044">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-6045">
              Is your drive shaft in need of repair? Do your CV joints or
              universal joints need repair?
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-6046">
              You may have a problem with your drive shaft, universal joints or
              CV joints if you experience any of the following conditions:
            </p>

            <div className="space-y-4" data-id="element-6047">
              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-6048">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-6049" />
                <div data-id="element-6050">
                  <p className="font-bold text-gray-900" data-id="element-6051">
                    1. Vibration While Driving
                  </p>
                  <p className="text-gray-700" data-id="element-6052">
                    The car or truck vibrates while driving down the road
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-6053">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-6054" />
                <div data-id="element-6055">
                  <p className="font-bold text-gray-900" data-id="element-6056">2. Clunking Sound</p>
                  <p className="text-gray-700" data-id="element-6057">
                    A clunking sound is heard upon putting the car or truck in
                    reverse or drive
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-6058">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-6059" />
                <div data-id="element-6060">
                  <p className="font-bold text-gray-900" data-id="element-6061">
                    3. Squeaking at Low Speeds
                  </p>
                  <p className="text-gray-700" data-id="element-6062">
                    A squeaking sound is heard while driving at lower speeds
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6063">
            <div className="grid md:grid-cols-3 gap-4" data-id="element-6064">
              <div className="text-center" data-id="element-6065">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520002.jpg200x200.jpg?opt=w3" alt="Drive shaft repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-6066" />
              </div>
              <div className="text-center" data-id="element-6067">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520009.jpg200x200.jpg?opt=w3" alt="Universal joint repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-6068" />
              </div>
              <div className="text-center" data-id="element-6069">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520007.jpg200x200.jpg?opt=w3" alt="CV joint repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-6070" />
              </div>
            </div>
          </div>

          {/* Services Header */}
          <div className="bg-[#B1050B] text-white rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-6071">
            <h2 className="text-2xl font-bold" data-id="element-6072">
              We service and repair the following drive shafts, CV Joints,
              Universal Joints (U-Joints)
            </h2>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6073">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-6074">
              {/* Passenger Cars */}
              <div data-id="element-6075">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-6076">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-6077" />
                  Passenger Car Repair
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-6078">
                  Drive Shaft, CV Joint, Universal Joint Repair (foreign or
                  domestic)
                </p>

                <div className="space-y-3 mb-4" data-id="element-6079">
                  <div className="flex items-start" data-id="element-6080">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6081" />
                    <span className="text-gray-700" data-id="element-6082">
                      Honda, Toyota, Nissan, Lexus, Audi, Land Rover, Porsche,
                      BMW, Mercedes and more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6083">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6084" />
                    <span className="text-gray-700" data-id="element-6085">
                      Ford, Jaguar, GM, Chevrolet, Chrysler, Dodge, Jeep and
                      more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6086">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6087" />
                    <span className="text-gray-700" data-id="element-6088">
                      Pick-ups and vans (foreign and domestic)
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6089">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6090" />
                    <span className="text-gray-700" data-id="element-6091">
                      4x4 vehicles, CV joints, and universal joints
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6092">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6093" />
                    <span className="text-gray-700" data-id="element-6094">
                      Limousines, race cars, custom cars, and more
                    </span>
                  </div>
                </div>
              </div>

              {/* Trucks */}
              <div data-id="element-6095">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-6096">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-6097" />
                  Truck Repair
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-6098">
                  Drive Shaft, CV Joint, Universal Joint (U-Joint) Repair (all
                  sizes, foreign or domestic)
                </p>

                <div className="space-y-3 mb-4" data-id="element-6099">
                  <div className="flex items-start" data-id="element-6100">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6101" />
                    <span className="text-gray-700" data-id="element-6102">
                      Ford F150, F250, F350, F450, F550 Super Duty pick up
                      trucks
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6103">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6104" />
                    <span className="text-gray-700" data-id="element-6105">
                      Chevrolet (Chevy) and GM trucks, four-wheel drive
                      (4WD/4X4)
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6106">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6107" />
                    <span className="text-gray-700" data-id="element-6108">Dodge Trucks</span>
                  </div>
                  <div className="flex items-start" data-id="element-6109">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6110" />
                    <span className="text-gray-700" data-id="element-6111">
                      Toyota trucks, Nissan Trucks, Honda and more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6112">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6113" />
                    <span className="text-gray-700" data-id="element-6114">
                      Buses, RVs, and Coaches
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6115">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6116" />
                    <span className="text-gray-700" data-id="element-6117">
                      Agricultural Equipment, Construction Equipment
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-6118">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-6119" />
                    <span className="text-gray-700" data-id="element-6120">
                      PTO Shafts, Aluminum Drive-shafts, steel drive shafts and
                      more
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-6121">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-6122">
              Complete Drive Shaft Services
            </h2>
            <p className="text-lg text-gray-700 text-center" data-id="element-6123">
              Drive Shaft Repair, Universal Joint Repair (U-Joint Repair), CV
              Joint Repair. Garretts is well prepared to inspect and repair
              drivelines, driveshafts, cv joints and universal joints (u-joints)
              for a wide range of vehicles from passenger cars and trucks
              (foreign and domestic) to heavy equipment, farm equipment,
              construction equipment, semi-trucks, race cars, custom cars and
              more. <strong data-id="element-6124">If it has a driveline, we can fix it.</strong>
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-6125">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6126">Do you have a question?</h2>
            <p className="text-xl mb-6" data-id="element-6127">
              Expert Drive Shaft, CV Joint, and U-Joint Repair
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6128">
              <Phone className="mr-3" size={24} data-id="element-6129" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6130">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}